import { useState } from "react";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Send, BellRing } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function SendReminderModal({ open, onOpenChange, ticket, onSent }) {
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);

  const submit = async () => {
    setSending(true);
    try {
      const { data } = await api.post(`/tickets/${ticket.id}/reminder`, { message });
      toast.success(`Reminder sent · count now ${data.reminder_count || 1}`);
      setMessage("");
      onSent?.(data);
      onOpenChange(false);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Failed to send reminder");
    } finally {
      setSending(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="send-reminder-modal" className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle className="font-heading flex items-center gap-2">
            <BellRing className="w-4 h-4 text-indigo-600" /> Send reminder
          </DialogTitle>
          <p className="text-xs text-slate-500 mt-1">
            Reminds the ticket owner and department POC. Reminder count:{" "}
            <span className="font-mono">{ticket?.reminder_count || 0}</span>
          </p>
        </DialogHeader>
        <div className="py-2 space-y-3">
          <div>
            <Label className="text-xs font-semibold text-slate-700">Note (optional)</Label>
            <Textarea
              data-testid="reminder-message-input"
              rows={4}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Anything specific the team should know? (Customer urgency, escalation context, etc.)"
              className="mt-1.5 resize-none"
            />
            <p className="text-[11px] text-slate-400 mt-1">{message.length}/500</p>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} data-testid="reminder-cancel-btn">
            Cancel
          </Button>
          <Button
            onClick={submit}
            disabled={sending}
            className="bg-indigo-600 hover:bg-indigo-700"
            data-testid="reminder-submit-btn"
          >
            <Send className="w-3.5 h-3.5 mr-1.5" />
            {sending ? "Sending..." : "Send reminder"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
